<template>
    <!-- 弹窗组件 -->
    <div class="global-popup-wrapper">
        <transition name="global-popup-fade">
            <div class="mask" v-show="isShow" @click="handleClickMask"></div>
        </transition>
        <transition name="global-popup-bounce">
            <div class="global-popup" v-show="isShow">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import ModalHelper from '../modalHelper/index.js';
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
    },

    created() {
        this.modalHelper = new ModalHelper({});
    },

    watch: {
        isShow(newVal) {
            this.modalHelper.toggleBlock(newVal);
        },
    },

    methods: {
        handleClickMask() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.global-popup-wrapper {
    .mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        z-index: 1999;
        transition: 0.2s;
    }

    .global-popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        -webkit-user-select: none;
        backface-visibility: hidden;
        transition: 0.2s;
        z-index: 2001;
    }

    .global-popup-bounce-enter {
        opacity: 0;
        transform: translate3d(-50%, -50%, 0) scale(0.7);
    }
    .global-popup-bounce-leave-active {
        opacity: 0;
        transform: translate3d(-50%, -50%, 0) scale(0.9);
    }

    .global-popup-fade-enter {
        opacity: 0;
    }
    .global-popup-fade-leave-active {
        opacity: 0;
    }
}
</style>
